import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react'
import InputWithStyle from "./InputWithStyle";
import { HcContext } from "../../types/hccontext";


interface SearchInputProps {
	searchValue: string;
	searchPath: string;
	placeholder: string;
	language: string;
	hcContext: HcContext;
	autoFocus?: boolean;
}

function SearchInput({ searchValue, searchPath, placeholder, language, hcContext, autoFocus = false }: Readonly<SearchInputProps>) {

	const navigate = useNavigate();
	const [editionValue, setEditionValue] = useState("");

	function goOnSearchPageIfInputNotEmpty(inputText: string | undefined) {
		if (inputText && inputText !== "") {
			const urlizedValue = encodeURIComponent(inputText);
			navigate(searchPath + urlizedValue)
		}
	}

	useEffect(() => {
		setEditionValue(searchValue)
	}, [searchValue]);


	return (
		<InputWithStyle onValidation={goOnSearchPageIfInputNotEmpty} value={editionValue}
			placeholder={placeholder}
			onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
				setEditionValue(event.target.value)
			}} language={language} hcContext={hcContext} hasSearchButton={true} autoFocus={autoFocus} />
	)

}

export default SearchInput
